function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#39C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.418 13.776v2.474h2.474M2.892.417H.418V2.89M19.585 2.89V.417h-2.474M17.111 16.25h2.474v-2.474"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#39C",
  strokeLinejoin: "round",
  d: "M2.918 4.167V12.5M4.585 4.167V10M6.252 4.167V10M8.752 4.167V10M10.418 4.167V10M12.085 4.167V10M13.752 4.167V10M15.418 4.167V10M17.085 4.167V12.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#39C",
  d: "M4.168 11.667H5v-.834h-.832zM5.835 11.667h.832v-.834h-.832zM8.335 11.667h.832v-.834h-.832zM10.002 11.667h.831v-.834h-.831zM11.668 11.667h.832v-.834h-.832zM13.335 11.667h.832v-.834h-.832zM15.002 11.667h.831v-.834h-.831z"
}));

var SvgScanIcon = function SvgScanIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scan_icon.bf929a3e.svg";
export { ForwardRef as ReactComponent };